import { Paper } from "@material-ui/core";

const GovGrTableContainer = (props) => {
  return (
    <Paper
      elevation={0}
      style={{
        width: "80vw",
        overflow: "auto",
      }}
      {...props}
    />
  );
};

export default GovGrTableContainer;
